import { render, staticRenderFns } from "./SingleBuilding.vue?vue&type=template&id=411e2034&"
import script from "./SingleBuilding.vue?vue&type=script&lang=js&"
export * from "./SingleBuilding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports